/**
 * @desc        Routes
 * @version     1.2.0 (Removed dashboard route) - 30 April 2026. Hopeing isnt no longer needed.
 * */

import { metadata } from 'app-config/index.js'
import { ErrorBoundary } from 'components/error-pages'
import { AnimatedLoader } from 'helpers/loaders.js'
import history from 'history/history.js'
import React, { Suspense } from 'react'
import fastCompare from 'react-fast-compare'
import { Redirect, Route, Router, Switch } from 'react-router-dom'
import { isFeatureRouteAvailable } from 'app-config/release-visibility.js'
import PrivateRoute from './private-routes.js'
import ScrollToTop from './ScrollToTop.js'

// BUMP
// FEATURE: DASHBOARD
// const Dashboard = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "dashboard" */ '../features/dashboard/dashboard.js')) : require('../features/dashboard/dashboard.js').default

// FEATURE: CHEMICALS RECORD
const ChemicalsRecord = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import('../features/chemicals-record/chemicals-record.js')) : require('../features/chemicals-record/chemicals-record.js').default
// const ChemicalRecordAsset = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import('../features/chemicals-record/chemicals-record-asset.js')) : require('../features/chemicals-record/chemicals-record-asset.js').default

// FEATURE: PADDOCKS
// const Fields = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "fields" */ '../features/paddocks_fields/fields.js')) : require('../features/paddocks_fields/fields.js').default
// const Field = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "field" */ '../features/paddocks_fields/field.js')) : require('../features/paddocks_fields/field.js').default

// FEATURE: SPRAYING
// const SprayingConditions = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import('../features/spraying-conditions/spraying-conditions.js')) : require('../features/spraying-conditions/spraying-conditions.js').default
const SprayConditionsV2 = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import('../features-v2/spray-conditions/spray-conditions.js')) : require('../features-v2/spray-conditions/spray-conditions.js').default

// FEATURE: PLANNER
const Planner = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "planner" */ '../features/planner/planner.js')) : require('../features/planner/planner.js').default
// FEATURE: TASKMANAGER
const TaskManager = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "task-manager" */ '../features/taskmanager/taskmanager.js')) : require('../features/taskmanager/taskmanager.js').default
const TaskManagerProject =
    process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "task-manager-project" */ '../features/taskmanager/taskmanager-project.js')) : require('../features/taskmanager/taskmanager-project.js').default

// FEATURE: SETTINGS
// const NewSettings = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "settings" */ '../features/settings/settings.js')) : require('../features/settings/settings.js').default

// FEATURE: AUTH
const ToDashboardRoute = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "to-dashboard-route" */ './to-dashboard.js')) : require('./to-dashboard.js').default
const Login = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "login" */ '../features/auth/login/login.js')) : require('../features/auth/login/login.js').default
const Logout = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "logout" */ '../features/auth/logout/logout.js')) : require('../features/auth/logout/logout.js').default
const Thanks = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "thanks" */ '../features/auth/logout/thanks.js')) : require('../features/auth/logout/thanks.js').default

const DeleteAccount = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "delete-account" */ '../features-v2/auth/delete-account.js')) : require('../features-v2/auth/delete-account.js').default

const ForgotPassword =
    process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "forgot-password" */ '../features/auth/forgot-password/forgot-password.js')) : require('../features/auth/forgot-password/forgot-password.js').default
const ResetPassword =
    process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "reset-password" */ '../features/auth/forgot-password/reset-password.js')) : require('../features/auth/forgot-password/reset-password.js').default
const Signup = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "signup" */ '../features/auth/signup/signup.js')) : require('../features/auth/signup/signup.js').default
const SignupEvents = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "signup-events" */ '../features/auth/signup/signup-events.js')) : require('../features/auth/signup/signup-events.js').default
const IOSRegistration = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "ios-registration" */ '../features/auth/ios-signup/ios-signup.js')) : require('../features/auth/ios-signup/ios-signup.js').default
const Confirm = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "confirm" */ '../features/auth/confirm/confirm.js')) : require('../features/auth/confirm/confirm.js').default
const ConfirmEvents = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "confirm-events" */ '../features/auth/confirm/confirm-events.js')) : require('../features/auth/confirm/confirm-events.js').default
const Resend = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "resend" */ '../features/auth/resend/resend.js')) : require('../features/auth/resend/resend.js').default
const EmailLink = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "email-link" */ '../features/auth/emaillink/emaillink.js')) : require('../features/auth/emaillink/emaillink.js').default
const DemoOnboard = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "demo-onboard" */ '../features-v2/demo/demo-onboard.js')) : require('../features-v2/demo/demo-onboard.js').default

// COMPONENT: SENSORS

// COMPONENT: ROUTING/MISC
const NotFound = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "not-found" */ '../features/auth/not-found/not-found.js')) : require('../features/auth/not-found/not-found.js').default

// VERSION 2 OF ROUTES
// FEATURE: ASSET SHELL
const AssetShell = process.env.REACT_APP_BUILD_MODE === 'web' ? React.lazy(() => import(/* webpackChunkName: "asset-shell" */ 'features-v2/assets/asset-shell.js')) : require('features-v2/assets/asset-shell.js').default

// new way of doing routes. please add here and delete from above.
const commonRoutes = [
    'assetTemplate',
    'energyConsumptionDashboard',
    'farmmap2',
    'fencingDashboard',
    'grazingPlan',
    'grazingPlanner',
    'paddockDashboard',
    'paddockPage',
    'paddocksV2Dashboard',
    'paddocksV2Detail',
    'primaryDashboard',
    'sensorDashboard',
    'sensorTemplate',
    'soilMoistureDashboard',
    'test',
    'vehicleCountingDashboard',
    'vehicles',
    'videosurveillance',
    'livestockCountingDashboard',
    'weather',
    'alertsDashboard',
    'waterresourcesDashboard',
    'systemSettings',
    'airQualityDashboard',
    'riskComplianceDashboard',
    'assetRegisterDashboard',
    'documentsDashboard',
    'operatingAccountsDashboard',
    'staffManagementDashboard',
    'assetRegisterAsset',
    'livestockTrackingDashboard',
    'coldStorageDashboard',
    // 'mob2',
    // 'animal2',
    'animalManagement',
    'sprayingConditionsDashboard',
    'rfidSessionsDashboard',
    'chemicalRegisterDashboard',
]

const Routes = React.memo(
    () => (
        <Router history={history}>
            <Suspense fallback={AnimatedLoader}>
                <Route
                    render={({ location }) => {
                        return (
                            <ErrorBoundary location={location}>
                                <ScrollToTop />

                                <Switch location={location}>
                                    <Route
                                        exact
                                        path="/:id/assets/water/:assetid"
                                        render={props => (
                                            <Redirect
                                                to={{
                                                    pathname: `/${props.match.params.id}/asset/${props.match.params.assetid}`,
                                                    state: {
                                                        ...props.location.state,
                                                        redirect: true,
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                    <Redirect exact from="/:id/assets/water" to="/:id/water-resources" />
                                    <Redirect exact from="/:id/chemicalsrecord/:assetid" to="/:id/asset/:assetid" />
                                    <Route exact path="/:id/property-risk-register" render={props => <Redirect to={{ pathname: `/${props.match.params.id}/risk-compliance`, search: props.location.search, state: props.location.state }} />} />
                                    <Route exact path="/:id/rfid-scanner" render={props => <Redirect to={{ pathname: `/${props.match.params.id}/rfid-sessions/new`, state: props.location.state }} />} />
                                    <Route exact path="/:id/rfid-scan-history" render={props => <Redirect to={{ pathname: `/${props.match.params.id}/rfid-sessions/history`, state: props.location.state }} />} />
                                    <Route exact path="/:id/rfid-scan-history/:sessionId" render={props => <Redirect to={{ pathname: `/${props.match.params.id}/rfid-sessions/history/${props.match.params.sessionId}`, state: props.location.state }} />} />

                                    {commonRoutes
                                        .filter(e => isFeatureRouteAvailable(metadata[e].route))
                                        .map(e => (
                                            <PrivateRoute exact key={e} path={`/:id/${metadata[e].route}`} render={props => <AssetShell {...props} metadata={metadata[e]} />} />
                                        ))}
                                    {isFeatureRouteAvailable(metadata.rfidSessionsDashboard.route) && (
                                        <PrivateRoute exact path={`/:id/${metadata.rfidSessionsDashboard.route}/:tab`} render={props => <AssetShell {...props} metadata={metadata.rfidSessionsDashboard} />} />
                                    )}
                                    {isFeatureRouteAvailable(metadata.rfidSessionsDashboard.route) && (
                                        <PrivateRoute exact path={`/:id/${metadata.rfidSessionsDashboard.route}/history/:sessionId`} render={props => <AssetShell {...props} metadata={metadata.rfidSessionsDashboard} />} />
                                    )}
                                    {isFeatureRouteAvailable(metadata.rfidSessionsDashboard.route) && (
                                        <PrivateRoute exact path={`/:id/${metadata.rfidSessionsDashboard.route}/uploaded/:sessionId`} render={props => <AssetShell {...props} metadata={metadata.rfidSessionsDashboard} />} />
                                    )}
                                    {/* animal-management deep routes */}
                                    <PrivateRoute exact path={`/:id/${metadata.animalManagement.route}/animal/:animalId`} render={props => <AssetShell {...props} metadata={metadata.animalManagement} />} />
                                    <PrivateRoute exact path={`/:id/${metadata.animalManagement.route}/group/:groupId`} render={props => <AssetShell {...props} metadata={metadata.animalManagement} />} />
                                    <PrivateRoute exact path={`/:id/${metadata.animalManagement.route}/cohort/:cohortId`} render={props => <AssetShell {...props} metadata={metadata.animalManagement} />} />

                                    <Route path={`/${metadata.demoOnboard.route}`} render={props => <DemoOnboard {...props} metadata={metadata.demoOnboard} />} />

                                    {/* <PrivateRoute path={`/:id/${metadata.dashboard.route}`} exact render={props => <Dashboard {...props} metadata={metadata.dashboard} />} /> */}

                                    <PrivateRoute path={`/:id/${metadata.chemicalsrecord.route}`} exact render={props => <ChemicalsRecord {...props} metadata={metadata.chemicalsrecord} />} />
                                    {/* <PrivateRoute path={`/:id/${metadata.chemicalsrecordAsset.route}`} exact render={props => <ChemicalRecordAsset {...props} metadata={metadata.chemicalsrecordAsset} />} /> */}
                                    {/* <PrivateRoute path={`/:id/${metadata.fields.route}`} exact render={(props) => <Fields {...props} metadata={metadata.fields} />} /> */}
                                    {/* <PrivateRoute path={`/:id/${metadata.field.route}`} render={(props) => <Field {...props} metadata={metadata.field} />} /> */}
                                    {/* <PrivateRoute path={`/:id/${metadata.assets.route}`} exact render={props => <Assets {...props} metadata={metadata.assets} />} />
                                    <PrivateRoute path={`/:id/${metadata.asset.route}`} render={props => <Asset {...props} metadata={metadata.asset} />} /> */}
                                    {/* Redirect from old asset detail route to new asset route */}

                                    {/* <PrivateRoute
                                        path={`/:id/${metadata.vehicle.route}`}
                                        exact
                                        render={props => {
                                            return <Vehicle {...props} metadata={metadata.vehicle} />
                                        }}
                                    /> */}

                                    {/* <PrivateRoute path={`/:id/${metadata.sprayingconditions.route}`} exact render={props => <SprayingConditions {...props} metadata={metadata.sprayingconditions} />} /> */}
                                    <PrivateRoute path={`/:id/${metadata.sprayconditionsv2.route}`} exact render={props => <SprayConditionsV2 {...props} metadata={metadata.sprayconditionsv2} />} />
                                    <PrivateRoute path={`/:id/${metadata.planner.route}`} exact render={props => <Planner {...props} metadata={metadata.planner} />} />
                                    <PrivateRoute path={`/:id/${metadata.taskmanager.route}`} exact render={props => <TaskManager {...props} metadata={metadata.taskmanager} />} />
                                    <PrivateRoute path={`/:id/${metadata.taskmanagerProject.route}`} render={props => <TaskManagerProject {...props} metadata={metadata.taskmanagerProject} />} />
                                    {/* <PrivateRoute path={`/:id/${metadata.newSettings.route}`} exact render={props => <NewSettings {...props} metadata={metadata.newSettings} />} /> */}

                                    <Route path={`/${metadata.logout.route}`} exact render={props => <Logout {...props} metadata={metadata.logout} />} />
                                    <Route path={`/${metadata.deleteAccount.route}`} exact render={props => <DeleteAccount {...props} metadata={metadata.deleteAccount} />} />
                                    <Route path={`/thanks`} exact render={props => <Thanks {...props} metadata={metadata.thanks} />} />

                                    <Route path={`/${metadata.forgotPassword.route}`} exact render={props => <ForgotPassword {...props} metadata={metadata.forgotPassword} />} />
                                    <Route path={`/${metadata.resetPassword.route}`} exact render={props => <ResetPassword {...props} metadata={metadata.resetPassword} />} />

                                    <Route
                                        path={`/${metadata.signup.route}`}
                                        exact
                                        render={props => {
                                            if (process.env.REACT_APP_BUILD_MODE !== 'web') return <IOSRegistration {...props} metadata={metadata.confirm}></IOSRegistration>
                                            return <Signup {...props} metadata={metadata.signup} />
                                        }}
                                    />
                                    <Route
                                        path={`/${metadata.signupEvents.route}`}
                                        exact
                                        render={props => {
                                            if (process.env.REACT_APP_BUILD_MODE !== 'web') return <IOSRegistration {...props} metadata={metadata.confirm}></IOSRegistration>
                                            return <SignupEvents {...props} metadata={metadata.signupEvents} />
                                        }}
                                    />
                                    <Route
                                        path={`/${metadata.confirm.route}`}
                                        exact
                                        render={props => {
                                            if (process.env.REACT_APP_BUILD_MODE !== 'web') return <IOSRegistration {...props} metadata={metadata.confirm}></IOSRegistration>
                                            return <Confirm {...props} metadata={metadata.confirm} />
                                        }}
                                    />
                                    <Route
                                        path={`/${metadata.confirmEvents.route}`}
                                        exact
                                        render={props => {
                                            if (process.env.REACT_APP_BUILD_MODE !== 'web') return <IOSRegistration {...props} metadata={metadata.confirmEvents}></IOSRegistration>
                                            return <ConfirmEvents {...props} metadata={metadata.confirmEvents} />
                                        }}
                                    />
                                    <Route
                                        path={`/${metadata.resend.route}`}
                                        exact
                                        render={props => {
                                            if (process.env.REACT_APP_BUILD_MODE !== 'web') return <IOSRegistration {...props} metadata={metadata.confirm}></IOSRegistration>
                                            return <Resend {...props} metadata={metadata.resend} />
                                        }}
                                    />
                                    <Route path={`/${metadata.emaillink.route}`} exact render={props => <EmailLink {...props} metadata={metadata.emaillink} />} />
                                    <ToDashboardRoute path={`/${metadata.login.route}`} exact render={props => <Login {...props} metadata={metadata.login} />} />
                                    <ToDashboardRoute
                                        path={metadata.home.route}
                                        exact
                                        render={props => {
                                            const search = props.location.search
                                            const hash = props.location.hash
                                            if (process.env.REACT_APP_BUILD_MODE === 'web') {
                                                return <Redirect to={{ pathname: '/auth/login', search, hash }} />
                                            }
                                            return <Redirect to={{ pathname: '/auth/login', search, hash }} />
                                        }}
                                    />
                                    <Route component={NotFound} />
                                </Switch>
                            </ErrorBoundary>
                        )
                    }}
                />
            </Suspense>
        </Router>
    ),
    fastCompare,
)

export default Routes
